import * as SwymKitConfig from '@ds/swymkit/stores'

/** Get PlatformID */
export function getPlatformId(): string | 'OnPremise' {
  return SwymKitConfig.getPlatformId()
}

/** Set PlatformID */
export function setPlatformId(value: string) {
  SwymKitConfig.setPlatformId(value)
}

/** Get Registry URL */
export function getRegistryUrl(): string {
  return SwymKitConfig.getRegistryUrl()
}

/** Set Registry URL */
export function setRegistryUrl(value: string) {
  let url = value
  if (isOnPremise()) {
    // on onPremise env, the registry url given by the backend is a MyApps url !
    // the suffix "resources/AppsMngtRegistry" is needed to convert the MyApps to the Registry url
    if (value.includes('resources/AppsMngtRegistry'))
      url = value

    else
      url = `${value}/resources/AppsMngtRegistry`.replace(/([^:]\/)\/+/g, '$1')
  }

  SwymKitConfig.setRegistryUrl(url)
}

/** Setter Swym URL */
export function setSwymUrl(url: string) {
  // @ts-expect-error this is the only methods allowed to edit this readonly attribute
  // Remove potential trailing "/" from the URL
  window.SWYM_URL = url.replace(/\/$/, '')
}

/** Getter Swym URL, it **never** ends with a "/" */
export function getSwymUrl() {
  return window.SWYM_URL
}

export function isOnPremise() {
  return getPlatformId()
    ?.toLowerCase() === 'onpremise'
}

export async function initSwymConfig(url: string) {
  try {
    const response: { tenant: string, url: string, registry_service_url: string } = await (await fetch(`${url}/swym-config.properties?bust=${(Date.now() / 1000).toFixed(0)}`)).json()
    // setPlatformId MUST be the first to be set
    setPlatformId(response.tenant)
    setRegistryUrl(response.registry_service_url)
    setSwymUrl(response.url)
  }
  catch (error: any) {
    if (import.meta.env.VITE_SWYM_URL && import.meta.env.VITE_SWYM_REGISTRY && import.meta.env.VITE_SWYM_URL) {
      setPlatformId(import.meta.env.VITE_SWYM_TENANT)
      setRegistryUrl(import.meta.env.VITE_SWYM_REGISTRY)
      setSwymUrl(import.meta.env.VITE_SWYM_URL)
    }
    else {
      throw new Error('Fetch to swym-config failed. Check your network.', error)
    }
  }
}

/** Reset variable to fix issue */
export function fixSwymConfig() {
  // Convert MyApps to registry for OnPremise
  if (window.SWYM_TENANT)
    setPlatformId(window.SWYM_TENANT)
  if (window.SWYM_REGISTRY_URL)
    setRegistryUrl(window.SWYM_REGISTRY_URL)
  // Remove trailing "/" from Swym URL
  setSwymUrl(getSwymUrl())
}
